export default function() {

    jQuery('[data-mobile-menu="hamburger"]').click(function(){

        // If closing, reset the menu.
        if( jQuery(this).hasClass('is-open') ) {

            jQuery('[data-mobile-menu="main"]').addClass('is-open');
            jQuery('.overlay').addClass('is-open');

            resetMobileMenu();

        }

        // Class toggle all hamburgers.
        jQuery('[data-mobile-menu="hamburger"]').toggleClass('is-open');

        // Class toggle the mobile menu.
        jQuery('[data-mobile-menu="menu"]').toggleClass('is-open');
        jQuery('.overlay').toggleClass('is-open');

    });

    jQuery('.overlay').click(function(){

        // Class toggle all hamburgers.
        jQuery('[data-mobile-menu="hamburger"]').toggleClass('is-open');

        // Class toggle the mobile menu.
        jQuery('[data-mobile-menu="menu"]').toggleClass('is-open');
        jQuery('.overlay').toggleClass('is-open');

        resetMobileMenu();

    });

    jQuery( '.drawer-menu li.has-submenu > a' ).click(function(){

        let val = jQuery(this).find('.categorie').text().trim();
        let depth = jQuery(this).find('.categorie').data('id');

        jQuery('.categorie-' + depth ).text( val );

        // Main menu sluiten, sub-menu geopend immers. Maakt niet uit welk niveau.
        jQuery('.drawer-menu-mobile-nav').removeClass('is-open');

        // Indien diepte meer dan 0, huidige sub-menu sluiten.
        if ( jQuery(this).parents('.has-submenu').length > 1 ) {

            // Move to leftt
            jQuery(this).parents('.drawer-menu-sub').css( 'transform', 'translateX(-100%)' );

        } else {

            // Move all subs to right
            jQuery('.drawer-menu-sub').css( 'transform', 'translateX(100%)' );


        }

        // Slide in selected
        jQuery(this).next( '.drawer-menu-sub' ).css( 'transform', 'translateX(0)' );

    });

    jQuery( '.drawer-menu-return' ).click(function(){

        // Move current back to right
        jQuery(this).parent('.drawer-menu-sub').css( 'transform', 'translateX(100%)' );

        // Slide in previous

        // Determine whether there is a parent sub
        if ( jQuery(this).parents('.drawer-menu-sub').length > 1 ) {

            jQuery(this).parents('.drawer-menu-sub').eq(1).css( 'transform', 'translateX(0)' ); // Not itself, but ancestor sub.

        } else {

            // Slide in main
            jQuery('.drawer-menu-mobile-nav').addClass('is-open');

        }

    });

    function resetMobileMenu() {

        // Enable main menu
        jQuery('.drawer-menu-mobile-nav').addClass('is-open');

        // Reset subs
        jQuery( '.drawer-menu-sub' ).css( 'transform', 'translateX(0)' );

    }

}